import { Field, Form, Formik } from 'formik';
import { Button, Collapse, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import { IOption } from '../../../models/ICommon';
import FormikFormFileInput from '../../../shared-components/FormikFormHandlers/FormikFormFileInput';
import { useEffect, useRef, useState } from 'react';
import { formatMessage } from '../../../translations/format-message';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import {
  ICorrectionFileList,
  IPreviousRaisedRequests,
} from '../../../models/forms/ICorrectionControl';
import {
  DeleteIcon,
  NoImageIcon,
  RequestCorrectionInfo,
  UploadCloudIcon,
} from '../../../shared-components/svgs/svgs';
import { CorrectionRequestValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import './correction-request-form.css';

const MAX_VISIBLE_REQUESTS = 2;

export interface IRemoveTaskFormProps {
  id: string;
  initialValues: any;
  isLoading: boolean;
  submitHandler: (data: any) => void;
  onModalClosed: () => void;
  allProductProcess: IOption[];
  productName: string;
  fileUploadService: (TenantId: number, data: any) => void;
  fileUploadSuccess?: boolean;
  previewFiles: ICorrectionFileList[];
  handleDelete: (index: number) => void;
  processId: number;
  userName: string;
  previousRequests: IPreviousRaisedRequests[];
  GetCorrectionRequestByIdService: (
    tenantId: number,
    Id: number
  ) => Promise<void>;
}

const CorrectionRequestForm = ({
  id,
  initialValues,
  isLoading,
  submitHandler,
  onModalClosed,
  allProductProcess,
  productName,
  fileUploadService,
  fileUploadSuccess,
  previewFiles,
  handleDelete,
  processId,
  userName,
  previousRequests,
  GetCorrectionRequestByIdService,
}: IRemoveTaskFormProps) => {
  const [files, setFiles] = useState<File[]>([]);
  const [fileInputKey, setFileInputKey] = useState<number>(0);
  const thumbGridRef = useRef<HTMLDivElement>(null);
  const [showAllRequests, setShowAllRequests] = useState<boolean>(false);

  useEffect(() => {
    if (fileUploadSuccess) {
      setFiles([]);
      setFileInputKey((prev) => prev + 1);
    }
  }, [fileUploadSuccess]);

  useEffect(() => {
    if (thumbGridRef.current) {
      thumbGridRef.current.scrollTo({
        top: thumbGridRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [previewFiles?.length]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const isAllowedType =
        file.type.startsWith('image/') || file.type === 'application/pdf';
      if (!isAllowedType) {
        toast.error(formatMessage('supported_only_image_or_pdf_format'));
        setFiles([]);
        event.target.value = '';
        return;
      }
      if ((previewFiles?.length ?? 0) >= 5) {
        toast.error(formatMessage('max_file_upload_limit_reached'));
        setFiles([]);
        event.target.value = '';
        return;
      }
      setFiles([file]);
    } else {
      setFiles([]);
    }
  };
  const handleSaveFile = () => {
    if (files.length > 0 && (previewFiles?.length ?? 0) < 5) {
      const file = files[0];
      fileUploadService(Number(getTenantIdFromLocalStorage()), {
        File: file,
      });
    }
  };

  const getDetailsHandler = (id: number) => {
    GetCorrectionRequestByIdService(Number(getTenantIdFromLocalStorage()), id);
  };

  const renderRequestBadge = (req: IPreviousRaisedRequests) => (
    <div
      className="badge text-break text-break-spaces fw-semibold bg-light text-dark border d-flex gap-1 align-items-center"
      key={req.Id}
    >
      <span>{req.DisplayMessage}</span>
      {/* <span onClick={() => getDetailsHandler(req.Id)}> */}
      <RequestCorrectionInfo />
      {/* </span> */}
    </div>
  );

  return (
    <>
      <Formik
        initialValues={{
          ModificationMessage: '',
          ProductId: productName,
          ProcessId: processId ? String(processId) : '-1',
          Title: '',
          UserId: '',
        }}
        enableReinitialize
        validationSchema={CorrectionRequestValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          submitHandler({
            ModificationMessage: values.ModificationMessage,
            ProductId: productName,
            ProcessId: Number(values.ProcessId),
            CorrectionFiles: previewFiles,
            Title: values.Title,
            // UserId: values.UserId,
          });
        }}
      >
        {() => {
          return (
            <Form className="user-form crf-form">
              {isLoading && <FormLoader loading={isLoading} contained />}
              <Modal.Body className="crf-body">
                {/* Request details */}
                <div className="row">
                  <div className="crf-card col-xl-7 col-xxl-7">
                    <div className="row">
                      <div className="formSet d-flex flex-column crf-field col-6">
                        <Label
                          required={false}
                          label="ProductId"
                        />

                        {/* <Field
                          data-testid="testProductId"
                          className="form-control"
                          name="ProductId"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          disabled={true}
                          value={productName}
                        /> */}
                        <p className="text-dark crf-product-name">
                          {productName}
                        </p>
                      </div>
                      <div className="formSet d-flex flex-column crf-field col-6">
                        <Label
                          required={false}
                          label="UserName"
                          className="mb-0"
                        />
                        {/* <Field
                          data-testid="testUserId"
                          className="form-control"
                          name="UserId"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          disabled={true}
                          value={''}
                        /> */}
                        <p className="text-dark crf-product-name">{userName}</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group formSet crf-field crf-span-2 col-6">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="title"
                        />
                        <Field
                          data-testid="testTitle"
                          className="form-control"
                          name="Title"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          disabled={false}
                        />
                      </div>
                      <div className="form-group formSet crf-field crf-span-2 col-6">
                        <Label
                          className="label-style  col-form-label"
                          required={true}
                          label="process"
                          htmlFor="ProcessId"
                        />
                        <Field
                          data-testid="ProcessId"
                          className="form-control"
                          name="ProcessId"
                          autoComplete="off"
                          placeholder=""
                          as={FormikFormSelect}
                          options={allProductProcess}
                        />
                      </div>
                    </div>

                    {previousRequests?.length > 0 && (
                      <div className="crf-previous-requests">
                        <div className="d-flex gap-2 align-items-start">
                          <div className="d-flex flex-wrap gap-2 flex-grow-1">
                            {previousRequests
                              .slice(0, MAX_VISIBLE_REQUESTS)
                              .map(renderRequestBadge)}
                          </div>
                          {previousRequests.length > MAX_VISIBLE_REQUESTS && (
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm ms-auto flex-shrink-0 crf-view-more"
                              onClick={() => setShowAllRequests((prev) => !prev)}
                              aria-expanded={showAllRequests}
                            >
                              {showAllRequests
                                ? formatMessage('view_less')
                                : `${formatMessage('view_more')} (+${
                                    previousRequests.length -
                                    MAX_VISIBLE_REQUESTS
                                  })`}
                            </button>
                          )}
                        </div>
                        {previousRequests.length > MAX_VISIBLE_REQUESTS && (
                          <Collapse in={showAllRequests}>
                            <div>
                              <div className="d-flex flex-wrap gap-2 pt-2">
                                {previousRequests
                                  .slice(MAX_VISIBLE_REQUESTS)
                                  .map(renderRequestBadge)}
                              </div>
                            </div>
                          </Collapse>
                        )}
                      </div>
                    )}
                    {/* Modification message */}
                    <div className="form-group formSet crf-field">
                      <Label
                        className="label-style col-form-label"
                        // required={true}
                        label="modification_message"
                      />
                      <Field
                        data-testid="testModificationDetails"
                        className="form-control crf-textarea"
                        name="ModificationMessage"
                        type="text"
                        as={FormikFormTextArea}
                      />
                    </div>
                  </div>
                  {/* Attachments */}
                  <div className="crf-card col-xl-5 col-xxl-5">
                    <div className="form-group formSet crf-field">
                      <Label
                        className="label-style col-form-label"
                        required={false}
                        label="correction_file"
                        htmlFor="ProcessId"
                      />
                      <div className="crf-upload-row">
                        <div className="crf-dropzone">
                          <Field
                            key={fileInputKey}
                            data-testid="ProcessId"
                            className="form-control"
                            name="CorrectionFile"
                            as={FormikFormFileInput}
                            accept="image/*,application/pdf"
                            onChange={handleFileChange}
                            // disabled={(previewFiles?.length ?? 0) >= 5}
                          />
                          <span className="crf-dropzone-icon">
                            <UploadCloudIcon />
                          </span>
                        </div>
                        <Button
                          className="crf-upload-btn"
                          variant="secondary"
                          onClick={handleSaveFile}
                          // disabled={
                          //   files.length === 0 ||
                          //   (previewFiles?.length ?? 0) >= 5
                          // }
                        >
                          {formatMessage('add')}
                        </Button>
                      </div>
                    </div>

                    {previewFiles?.length > 0 ? (
                      <div
                        className="crf-thumb-grid"
                        ref={thumbGridRef}
                      >
                        {previewFiles.map((file, index) => {
                          const filePath =
                            file?.S3FilePath || file?.FilePath || '';
                          const cleanPath = filePath
                            .split('?')[0]
                            .toLowerCase();
                          const isPdf =
                            (file as any)?.FileType === 'application/pdf' ||
                            cleanPath.endsWith('.pdf') ||
                            cleanPath.includes('.pdf');
                          return (
                            <div
                              key={index}
                              className="crf-thumb"
                            >
                              <span className="crf-thumb-badge">
                                {isPdf ? 'PDF' : 'IMG'}
                              </span>
                              <button
                                type="button"
                                className="crf-thumb-delete"
                                onClick={() => handleDelete(index)}
                                title={formatMessage('delete')}
                                aria-label={formatMessage('delete')}
                              >
                                <DeleteIcon />
                              </button>
                              {isPdf ? (
                                <iframe
                                  src={file.S3FilePath}
                                  className="crf-thumb-media"
                                  title={`pdf-${index}`}
                                />
                              ) : (
                                <img
                                  src={file.S3FilePath}
                                  alt={`preview-${index}`}
                                  className="crf-thumb-media"
                                />
                              )}
                              <span className="crf-thumb-name">
                                {file.FileName}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="crf-empty-state">
                        <span className="crf-empty-icon">
                          <NoImageIcon />
                        </span>
                        <span className="crf-empty-text">
                          {formatMessage('no_image_uploaded')}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={Number(id)}
                onModalClosed={onModalClosed}
                isLoading={isLoading}
                saveNextBtn={'submit'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CorrectionRequestForm;
